import { resourceActions, toolFilterAvailableTools } from '@/modules/authorization/config';

// Permisos disponibles de contenido, elimina editChannel
resourceActions.contents = [
  'create',
  'clone',
  'edit',
  'editTags',
  'publish',
  'unpublish',
  'delete',
];

// Añadimos permisos para la herramienta de reportes
toolFilterAvailableTools.push('reports', 'hrefLang');
